
class ClientService {
  constructor(NetworkService) {
    'ngInject';

    this.networkService = NetworkService;
  }

  getAllUsersApplicationsRoles(callback) {
    this.networkService.execute('GET', '/users/applications/roles', null, callback);
  }

  getAllApplicationsRoles(callback) {
    this.networkService.execute('GET', '/applications/roles', null, callback);
  }

  updateUser(id, data, callback) {
    this.networkService.execute('POST', '/user', {id: id, data:data}, callback);
  }

  getUserPermissions(userId, callback) {
    this.networkService.execute("GET", `/user/permission?id=${userId}`, null, callback)
  }

  updateUserPermissions(data, callback) {
    this.networkService.execute("PUT", '/user/permission', data, callback)
  }

}

export default ClientService;



// WEBPACK FOOTER //
// ./client/app/_services/client.service.js